import { render, staticRenderFns } from "./receipt_details.vue?vue&type=template&id=305e533f&scoped=true&"
import script from "./receipt_details.vue?vue&type=script&lang=js&"
export * from "./receipt_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305e533f",
  null
  
)

export default component.exports